import { render, staticRenderFns } from "./DefaultIntegrationForm.vue?vue&type=template&id=2f371c32"
import script from "./DefaultIntegrationForm.vue?vue&type=script&lang=js"
export * from "./DefaultIntegrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports